import {Component, Input, OnInit} from '@angular/core';
import {CalendarEvent} from "../../../../../shared/interfaces/shared-interface";
import {TagModule} from "primeng/tag";
import {TooltipModule} from "primeng/tooltip";
import {DatePipe, NgForOf, NgIf} from "@angular/common";

@Component({
    selector: 'app-events-board',
    standalone: true,
    imports: [
        TagModule,
        TooltipModule,
        DatePipe,
        NgForOf,
        NgIf
    ],
    templateUrl: './events-board.component.html',
    styleUrl: './events-board.component.scss'
})
export class EventsBoardComponent implements OnInit {
    constructor() {
    }
    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
    }
    @Input() events!: CalendarEvent[];
    tagBgStyle(status: CalendarEvent) {
        switch (status.status) {
            case 'Pendiente':
                return {background: status.backgroundColor};
            case 'Aprobado':
                return {background: status.backgroundColor};
            case 'Cancelado':
                return {background: status.backgroundColor};
            case 'Completado':
                return {background: status.backgroundColor};
            default:
                return {background: '#6c757d'};
        }
    }
    tagColorStyle(status: CalendarEvent) {
        switch (status.status) {
            case 'Pendiente':
                return {color: status.textColor};
            case 'Aprobado':
                return {color: status.textColor};
            case 'Cancelado':
                return {color: status.textColor};
            case 'Completado':
                return {color: status.textColor};
            default:
                return {color: '#6c757d'};
        }
    }
}
